import { PHONE_NUMBER, REQUIRED_ONBOARDING } from 'pricing-pages-api/EarlyRequesterNames';
import { GET_PHONE_NUMBER } from 'pricing-pages-api/phone-number/queries';
import { GET_REQUIRED_ONBOARDING } from 'pricing-pages-api/required-onboarding/queries';
import { getPublicMetaData } from 'pricing-pages-lib/api/PublicMetaDataApi';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { EN } from 'self-service-api/constants/Languages';
import { dataFetchingClient } from '../utils/dataFetchingClient';
import { PUBLIC } from './constants/RequestedDataTypes';
import { setPublicFeatureFlags } from './FeatureFlagActions';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { FetchPromotionActions } from './PromotionActions';
import { FetchRequiredOnboardingActions } from './RequiredOnboardingActions';
export const FetchPublicMetaDataRequestTypes = createRequestTypes(PUBLIC);
export const FetchPublicMetaDataActions = createRequestActions(FetchPublicMetaDataRequestTypes);
export const fetchPublicMetaData = () => {
  return dispatch => {
    dispatch(FetchPublicMetaDataActions.request());
    dispatch(FetchPromotionActions.request());
    dispatch(FetchRequiredOnboardingActions.request());
    return getPublicMetaData().then(resp => {
      dispatch(FetchPublicMetaDataActions.receive());
      const {
        promotions,
        requiredOnboardingResult,
        phoneNumber,
        activeFeatureFlags
      } = resp;
      dispatch(FetchPromotionActions.receive(promotions));
      dispatch(FetchRequiredOnboardingActions.receive({
        requiredOnboarding: requiredOnboardingResult
      }));
      dataFetchingClient.writeQuery({
        query: GET_REQUIRED_ONBOARDING,
        data: {
          requiredOnboarding: requiredOnboardingResult
        },
        variables: {
          earlyRequestName: REQUIRED_ONBOARDING
        }
      });
      const preferredLanguage = getPreferredLanguage() || EN;
      dataFetchingClient.writeQuery({
        query: GET_PHONE_NUMBER,
        data: {
          phoneNumber: {
            phoneNumber
          }
        },
        variables: {
          earlyRequestName: PHONE_NUMBER,
          preferredLanguage
        }
      });
      dispatch(setPublicFeatureFlags({
        activeFeatureFlags
      }));
    }).catch(error => {
      dispatch(FetchPublicMetaDataActions.failure(error));
      dispatch(FetchPromotionActions.failure(error));
      dispatch(FetchRequiredOnboardingActions.failure(error));
      throw error;
    });
  };
};